import React from 'react';
import AltContainer from 'alt-container';
import connectToStores from 'alt-utils/lib/connectToStores';

import CallerTeamComboboxSearchField from 'components/pure/search/CallerTeamComboboxSearchField';
import CallerTeamComboboxSearchFieldStore from 'stores/search/CallerTeamComboboxSearchFieldStore';

class CallerTeamComboboxSearchFieldContainer extends React.Component {
  static getStores() {
    return [CallerTeamComboboxSearchFieldStore];
  }

  static getPropsFromStores() {
    const searchFieldStore = CallerTeamComboboxSearchFieldStore.getState();
    return {
      CallerTeamComboboxSearchFieldStore: searchFieldStore.toObject(),
    };
  }

  render() {
    return (
      <AltContainer>
        <CallerTeamComboboxSearchField
          {...this.props}
          teams={this.props.CallerTeamComboboxSearchFieldStore.teams}
          canToggleCallerField={this.props.CallerTeamComboboxSearchFieldStore.canToggleCallerField}
          managers={this.props.CallerTeamComboboxSearchFieldStore.managers}
          reps={this.props.CallerTeamComboboxSearchFieldStore.reps}
          selectedManagers={this.props.CallerTeamComboboxSearchFieldStore.selectedManagers}
          selectedReps={this.props.CallerTeamComboboxSearchFieldStore.selectedReps}
          selectedTeams={this.props.CallerTeamComboboxSearchFieldStore.selectedTeams}
          updateLastToggledOnSearchWidget={this.props.updateLastToggledOnSearchWidget}
          shouldFocus={this.props.shouldFocus}
          shouldSortByToggled={this.props.shouldSortByToggled}
        />
      </AltContainer>
    );
  }
}

export default connectToStores(CallerTeamComboboxSearchFieldContainer);
